import { Flex, type FlexProps, mergeSx, Text } from '@shared/components';

export interface SummaryItemProps extends FlexProps {
  title: string;
  amount: string | number | null;
  percentage: number | string | null;
}

export default function SummaryItem(props: Readonly<SummaryItemProps>) {
  const { title, amount, percentage, sx, ...restProps } = props;

  return (
    <Flex {...restProps} sx={mergeSx({ flexDirection: 'column', minWidth: '100px', flex: 1 }, sx)}>
      <Text variant='body2' sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {title}
      </Text>
      <Flex
        sx={(theme) => ({
          alignItems: 'baseline',
          gap: theme.spacing(0.5),
          flexWrap: 'wrap',
          flexDirection: 'column',
        })}
      >
        {/* TODO:Setup theme typography */}
        <Text variant='h5' sx={{ fontSize: 18, fontWeight: 600, flexShrink: 0 }}>
          {amount ?? '-'} ข้อ
        </Text>
        <Text
          variant='caption'
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            flexShrink: 0,
          })}
        >
          ({percentage ?? '-'}%)
        </Text>
      </Flex>
    </Flex>
  );
}
